export default function (heapPayload = {}) {
	console.log('calling web...');
	$(document).ready(() => {
		setTimeout(
			() => {
				const isInfoBoxPresent = Bark.sellerSelfObject?.infobox;
                const isBannerPlaceHolderPresent = $('#__rctSellerEnquiriesBanner').length &&
                    !$('#__rctSellerEnquiriesBanner').html().length;
				if (
					isBannerPlaceHolderPresent &&
					!!window?.SellerApp &&
					!isInfoBoxPresent
				) {
					const queryString = window.location.search;
					const urlParams = new URLSearchParams(queryString);
					heapPayload = {
						...heapPayload,
						...{ is_specific_project: !!urlParams.get('prx') },
					};
					console.log('called banner module');
					window.SellerApp?.launchModule(
						'enquiries-banner',
						'__rctSellerEnquiriesBanner',
						{ heapPayload },
					);

					const barkHeader = $('.bark-header.sticky-top');
					const enquiriesBanner = $('.enquiriesbanner');

					$('body').on('DOMSubtreeModified', '.sticky-top.enquiriesbanner', function () {
						if (
							$('#__rctSellerEnquiriesBanner').length &&
							!!$('#__rctSellerEnquiriesBanner').html().length
						) {
							// if review banner is present on mobile remove stickiness
							if ($('#__rctSellerEnquiriesBanner > .tw-sticky >[aria-label="review-banner"]').length && window.Bark.isMobile() ) {
								enquiriesBanner.removeClass('sticky-top');
								barkHeader.css('top', 0);
							} else {
								if (!enquiriesBanner.hasClass('sticky-top')) {
									enquiriesBanner.addClass('sticky-top');
								}
								barkHeader.css('top', $('#__rctSellerEnquiriesBanner').height());
							}
						} else {
							barkHeader.css('top', '');
						}
					});
					$(window).resize(function () {
						if (
							$('#__rctSellerEnquiriesBanner').length &&
							!!$('#__rctSellerEnquiriesBanner').html().length
						) {
							// if review banner is present on mobile remove stickiness 
                            if(window.Bark.isMobile()){
                                if ($('#__rctSellerEnquiriesBanner > .tw-sticky >[aria-label="review-banner"]').length) {
                                    barkHeader.css('top', 0);
                                } else {
                                    barkHeader.css('top', $('#__rctSellerEnquiriesBanner').height())
                                }
                            }else {
								barkHeader.css('top', $('#__rctSellerEnquiriesBanner').height());
							}
						} else {
							barkHeader.css('top', '');
						}
					});
				}
			},
			!window?.SellerApp ? 1500 : 0,
		);
	});
}
